import { createSlice } from '@reduxjs/toolkit';
import {
  GET_ORDERS_DATA
} from '../constants/constants';

const initialState = {
  data: [],
  totalPages: 1
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(GET_ORDERS_DATA, (state, action) => {
      state.data = action.data.book_orders;
      state.totalPages = action.data.total_pages;
    });
  }
});

export default ordersSlice.reducer;
